import Navbar from "./Navbar"
import Slide from "./Slide"
import Main from "./Main"
import Tour from "./Tour"
import Mxh from "./Mxh"
import Footer from "./Footer"
export default function  Travel() {
  return(
    <div>
      <Navbar />
      <Slide />
      <Main />
      <Tour />
      <Mxh />
      <Footer />
    </div>
  )
}